import React, { PureComponent } from "react";
import { Input } from "antd";
import numeral from "numeral";

export default class InputNumber extends PureComponent {
  state = { value: "" };

  _handleChangeNumber = (e) => {
    const { onChange } = this.props;
    const raw = e.target.value;
    // Allow typing an intermediate "-" while entering a negative number.
    if (raw === "-") {
      this.setState({ typing: "-" });
      onChange && onChange(0);
      return;
    }
    this.setState({ typing: undefined });
    // const number = parseInt(e.target.value || 0, 10);
    const number = raw ? numeral(raw).value() : 0;
    if (number === null || isNaN(number)) {
      return;
    }
    onChange && onChange(number);
  };

  render() {
    const { value } = this.props;
    const { typing } = this.state;
    const displayValue =
      typing !== undefined ? typing : value ? numeral(value).format("0,0") : value;
    return (
      <Input
        {...this.props}
        onChange={this._handleChangeNumber}
        value={displayValue}
      />
    );
  }
}
